export default __webpack_public_path__ + "static/media/Image-19.3266c887.jpg";